import React, { useState } from "react";
import { ResponsiveContainer, BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts";

export default function RosCharts({ summary }) {
  const [show, setShow] = useState(true);
  const [metric, setMetric] = useState("kg");
  const data = (summary || []).filter((s) => s.ingekocht || s.output);

  return (
    <div className="bg-white rounded-lg border border-slate-200 p-4" data-testid="ros-trends">
      <div className="flex items-center justify-between mb-3">
        <div className="font-semibold text-slate-700">Weekvergelijking</div>
        <div className="flex gap-1">
          <button data-testid="ros-trends-toggle" onClick={() => setShow((v) => !v)} className="text-xs rounded border border-slate-300 px-2.5 py-1 hover:bg-slate-50">{show ? "Verbergen" : "Tonen"}</button>
          {show && (
            <>
              <button data-testid="ros-trends-kg" onClick={() => setMetric("kg")} className={`text-xs rounded px-2.5 py-1 transition-colors ${metric === "kg" ? "bg-[#1C64B0] text-white" : "border border-slate-300 hover:bg-slate-50"}`}>Volume (kg)</button>
              <button data-testid="ros-trends-pct" onClick={() => setMetric("pct")} className={`text-xs rounded px-2.5 py-1 transition-colors ${metric === "pct" ? "bg-[#1C64B0] text-white" : "border border-slate-300 hover:bg-slate-50"}`}>Rendement (%)</button>
            </>
          )}
        </div>
      </div>

      {!show ? null : data.length === 0 ? (
        <div className="text-sm text-slate-400 py-12 text-center">Nog geen gevulde weken om te vergelijken. Lees data in per week.</div>
      ) : metric === "kg" ? (
        <ResponsiveContainer width="100%" height={340}>
          <BarChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} />
            <Tooltip formatter={(v) => Number(v).toLocaleString("nl-NL") + " kg"} />
            <Legend />
            <Bar dataKey="ingekocht" name="Ingekocht (kg)" fill="#1C64B0" radius={[3, 3, 0, 0]} />
            <Bar dataKey="output" name="Output (kg)" fill="#7a1420" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <ResponsiveContainer width="100%" height={340}>
          <LineChart data={data} margin={{ top: 8, right: 12, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" />
            <XAxis dataKey="label" tick={{ fontSize: 12 }} />
            <YAxis tick={{ fontSize: 12 }} unit="%" />
            <Tooltip formatter={(v) => Number(v).toLocaleString("nl-NL") + "%"} />
            <Legend />
            <Line type="monotone" dataKey="filetPct" name="Filet %" stroke="#1C64B0" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="karkasPct" name="Karkas %" stroke="#16a34a" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="vellenPct" name="Vellen %" stroke="#d97706" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="vbeenPct" name="V been %" stroke="#7c3aed" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="catilagePct" name="CATILAGE %" stroke="#0891b2" strokeWidth={2} dot={false} />
            <Line type="monotone" dataKey="afvalPct" name="Afval % (vocht+Cat 2/3)" stroke="#dc2626" strokeWidth={2} dot={false} />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}
